import React from 'react';
import { GeoJSON, Popup } from 'react-leaflet';

interface ElevationHazardsProps {
  elevationHazards: any | null | undefined;
}

export const ElevationHazards = ({ elevationHazards }: ElevationHazardsProps) => {
  // Check if we have a valid GeoJSON FeatureCollection
  if (!elevationHazards || !elevationHazards.features || elevationHazards.features.length === 0) {
    return null;
  }

  return (
    <GeoJSON
      data={elevationHazards}
      style={{
        color: 'black',
        weight: 2,
        fillColor: 'black',
        fillOpacity: 0.5
      }}
      key={`elevation-hazards-${JSON.stringify(elevationHazards.features.length)}`}
      onEachFeature={(feature, layer) => {
        const properties = feature.properties || {};
        layer.bindPopup(`
          <div>
            <strong>Type:</strong> Elevation Hazard<br />
            ${properties.name ? `<strong>Name:</strong> ${properties.name}<br />` : ''}
            ${properties.description ? `<strong>Description:</strong> ${properties.description}<br />` : ''}
          </div>
        `);
      }}
    />
  );
};

export default ElevationHazards;

